"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpModel = void 0;
/* eslint-disable max-len */
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const formQuestionsToFormWithTree_1 = __importDefault(require("@opsbase/lib-form/convert/formQuestionsToFormWithTree"));
const updateActiveQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/updateActiveQuestions"));
const DeviceType_1 = __importDefault(require("@opsbase/lib-general/DeviceType"));
const GradingMethod_1 = __importDefault(require("@opsbase/lib-grading/GradingMethod"));
const PassStatus_1 = __importDefault(require("@opsbase/lib-grading/PassStatus"));
const calcOpStatus_1 = __importDefault(require("@opsbase/lib-op/helpers/calcOpStatus"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class OpModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.title = '';
        this.description = '';
        this.allPTsPermitted = false;
        this.opDefinitionId = '';
        this.opScheduleId = '';
        this.popDefinitionId = '';
        this.staff = [];
        this.teams = [];
        this.positions = [];
        this.issues = [];
        this.form = [];
        this.hasImage = false;
        this.opPerformedLocation = '';
        this.isScoreEnabled = false;
        this.isScorePublic = false;
        this.gradingMethod = new GradingMethod_1.default();
        this.isGradingPublic = false;
        this.allowIssuesAndNotes = false;
        this.canBePerformedOnlyOnNative = false;
        this.grade = undefined;
        this.percComplete = 0;
        this.finalScoreTotal = 0;
        this.finalScoreMax = 0;
        this.passFailStatus = PassStatus_1.default.UNDETERMINED;
        this.completedOnDeviceType = DeviceType_1.default.NATIVE;
        this.isAdhoc = false;
        this.conversations = [];
        super.init(o);
    }
    get __typename() {
        return 'Op';
    }
    set __typename(v) {
    }
    get status() {
        return (0, calcOpStatus_1.default)(this);
    }
    getParsedForm() {
        if (!this._parsedForm) {
            this._parsedForm = (0, formQuestionsToFormWithTree_1.default)(this.form);
            (0, updateActiveQuestions_1.default)(this._parsedForm);
        }
        return this._parsedForm;
    }
}
exports.OpModel = OpModel;
OpModel.ALL_FIELDS = `id,
		title,
		description,
		startFrom,
		completeBy,
		viewableDate,
		actualStart,
		actualComplete,
		missedDeadlineDate,
		createdDate,
		updatedDate,
		approvedDate,
		closedDate,
		hasImage,
		form,
		place { id, title, timezone },
        staff {  id, title, profileImageUrl, hasProfileImage },
        teams { id, title },
        positions { id, title},
		allPTsPermitted,
		opDefinitionId,
		awaitingApproval,
		opScheduleId,
		type,
		createdBy {  id, title, profileImageUrl, hasProfileImage },
		startedBy {  id, title, profileImageUrl, hasProfileImage },
	    updatedBy {  id, title, profileImageUrl, hasProfileImage },
	    submittedBy {  id, title, profileImageUrl, hasProfileImage },
	    approvedBy {  id, title, profileImageUrl, hasProfileImage },
	    closedBy {  id, title, profileImageUrl, hasProfileImage },
		issues { id, status, flag },
		isAdhoc,
		grade,
		finalScoreTotal,
		finalScoreMax,
		percComplete,
		opPerformedLocation,
		isScoreEnabled,
		isScorePublic,
		gradingMethod,
		isGradingPublic,
		allowIssuesAndNotes,
		canBePerformedOnlyOnNative,
		completedOnDeviceType,
		passFailStatus
		conversations {
		    	__typename, id, title, messages,
				participants { id, title, hasProfileImage, profileImageUrl }
		}`;
exports.default = OpModel;
ModelRegistry_1.default[DataType_1.default.OP] = OpModel;
ModelRegistry_1.default[DataType_1.default.OP_TODO] = OpModel;
